import { apiRequest } from '../lib/apiClient';

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

export const getTrainingSessions = (token) =>
  apiRequest('/training-sessions', { headers: authHeaders(token) }, 'Failed to load training sessions.');

export const createTrainingSession = (token, payload) =>
  apiRequest(
    '/training-sessions',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders(token),
      },
      body: JSON.stringify(payload),
    },
    'Failed to submit training session.'
  );
